import _ from 'lodash';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { decodeAsArray, encodeArray } from 'utils';

export function useUserDownline() {
  const { encodedUsersSelectedPath } = useParams();
  const navigate = useNavigate();

  const selectedUserId = useMemo(() => {
    const selectedUsersPath = _.isUndefined(encodedUsersSelectedPath)
      ? []
      : decodeAsArray(encodedUsersSelectedPath);

    if (selectedUsersPath.length === 0) {
      return undefined;
    }

    if (selectedUsersPath.length === 1) {
      return selectedUsersPath[0];
    }

    return selectedUsersPath[selectedUsersPath.length - 1];
  }, [encodedUsersSelectedPath]);

  const goToUserDownline = (userId: string) => {
    if (selectedUserId === userId) {
      return;
    }

    if (!_.isUndefined(encodedUsersSelectedPath)) {
      const decodedState = decodeAsArray(encodedUsersSelectedPath);
      const newStateToEncode = [
        ..._.takeWhile(decodedState, predicate => predicate !== userId),
        userId
      ];
      const encodedState = encodeArray(newStateToEncode);
      navigate(`/downline/${encodedState}`);
    } else {
      const newStateToEncode = [userId];
      const encodedState = encodeArray(newStateToEncode);
      navigate(`/downline/${encodedState}`);
    }
  };

  return {
    selectedUserId,
    goToUserDownline
  };
}
